import React from 'react';

export default function ReadingIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      viewBox="0 0 60 60"
      enableBackground="new 0 0 60 60"
      xmlSpace="preserve"
      fill="none"
      className="text-skin-text"
    >
      <g>
        <path fill="currentColor" d="M47.5,36h-35c-0.553,0-1,0.447-1,1s0.447,1,1,1h35c0.553,0,1-0.447,1-1S48.053,36,47.5,36z" />
        <path fill="currentColor" d="M34.5,31h13c0.553,0,1-0.447,1-1s-0.447-1-1-1h-13c-0.553,0-1,0.447-1,1S33.947,31,34.5,31z" />
        <path fill="currentColor" d="M34.5,24h13c0.553,0,1-0.447,1-1s-0.447-1-1-1h-13c-0.553,0-1,0.447-1,1S33.947,24,34.5,24z" />
        <path fill="currentColor" d="M34.5,17h13c0.553,0,1-0.447,1-1s-0.447-1-1-1h-13c-0.553,0-1,0.447-1,1S33.947,17,34.5,17z" />
        <path fill="currentColor" d="M47.5,48h-35c-0.553,0-1,0.447-1,1s0.447,1,1,1h35c0.553,0,1-0.447,1-1S48.053,48,47.5,48z" />
        <path fill="currentColor" d="M12.5,44h14c0.553,0,1-0.447,1-1s-0.447-1-1-1h-14c-0.553,0-1,0.447-1,1S11.947,44,12.5,44z" />
        <path fill="currentColor" d="M47.5,42h-13c-0.553,0-1,0.447-1,1s0.447,1,1,1h13c0.553,0,1-0.447,1-1S48.053,42,47.5,42z" />
        <path
          fill="currentColor"
          d="M31.21,43.71c0.18-0.19,0.29-0.45,0.29-0.71c0-0.261-0.11-0.521-0.29-0.7c-0.37-0.38-1.061-0.38-1.42-0.01   c-0.181,0.189-0.29,0.449-0.29,0.71c0,0.26,0.109,0.52,0.29,0.71C29.979,43.89,30.229,44,30.5,44C30.76,44,31.02,43.89,31.21,43.71   z"
        />
        <path
          fill="currentColor"
          d="M54.5,4h-25V1c0-0.553-0.447-1-1-1h-16c-0.553,0-1,0.447-1,1v3h-6c-0.553,0-1,0.447-1,1v54c0,0.553,0.447,1,1,1h49   c0.553,0,1-0.447,1-1V5C55.5,4.447,55.053,4,54.5,4z M53.5,58h-47V6h5v23c0,0.379,0.214,0.725,0.553,0.895   c0.339,0.169,0.745,0.134,1.047-0.095l7.4-5.55l7.4,5.55c0.082,0.062,0.173,0.106,0.267,0.14c0.034,0.012,0.069,0.016,0.104,0.024   c0.062,0.014,0.122,0.027,0.186,0.03c0.015,0,0.029,0.007,0.044,0.007c0.017,0,0.032-0.011,0.049-0.012   c0.136-0.006,0.272-0.031,0.399-0.094C29.286,29.725,29.5,29.379,29.5,29V6h24V58z"
        />
      </g>
    </svg>
  );
}
